import {
	Container,
	Content,
	MessageError,
	Label,
	Check,
	ContentCheckBox,
} from './styles'

export default function CheckBox({
	errorMessage = false,
	checked = false,
	handleCheckBoxChange = {},
	disabled = false,
	label = undefined,
	style = {},
}) {
	return (
		<Container style={style}>
			<Content>
				<ContentCheckBox>
					<Check
						onChange={handleCheckBoxChange}
						checked={checked}
						disabled={disabled}
					/>
					<Label>{label}</Label>
				</ContentCheckBox>
			</Content>
			{errorMessage ? (
				<MessageError>{errorMessage || <br />}</MessageError>
			) : null}
		</Container>
	)
}
